import { LoginManagementRoutes } from "../LoginManagementRoutes";

const ROOT = LoginManagementRoutes.GID;

export const GidSettingsRoutes = {
    ROOT,
    ONBOARDING_LIMIT: ROOT + "/limit",
    ONBOARDING_LIMIT_SIGNING: ROOT + "/limit/signing",
    LIMIT: ROOT + "/limit-management",
    LIMIT_SIGNING: ROOT + "/limit-management/signing",
    LIMIT_SUCCESS: ROOT + "/limit-management/success",
    USERMANAGEMENT: ROOT + "/usermanagement",
    USERMANAGEMENT_USERNAME: ROOT + "/usermanagement/username",
    USERMANAGEMENT_USERNAME_SIGNING: ROOT + "/usermanagement/username-signing",
    USERMANAGEMENT_USERNAME_SUCCESS: ROOT + "/usermanagement/username-success",
    USERMANAGEMENT_DELETE_USERNAME_SIGNING: ROOT + "/usermanagement/delete-username-signing",
    USERMANAGEMENT_DELETE_USERNAME_SUCCESS: ROOT + "/usermanagement/delete-username-success",
    USERNAME: ROOT + "/username",
    USERNAME_SIGNING: ROOT + "/username-signing",
    USERNAME_SUCCESS: ROOT + "/username-success",
    DELETE_USERNAME_SIGNING: ROOT + "/delete-username-signing",
    DELETE_USERNAME_SUCCESS: ROOT + "/delete-username-success",
    DELETE_DEVICE_SIGNING: ROOT + "/delete-device",
    DELETE_DEVICE_SUCCESS: ROOT + "/delete-success",
    ERROR_SIGNING_METHOD: ROOT + "/error-signing-method"
};



// WEBPACK FOOTER //
// ./src/components/loginManagement/gidSettings/GidSettingsRoutes.ts